import Logger from '../logger/logger';

// Smallest width or height a viewport, in km
// Can be adjusted as will
const viewportMinSize = 2;

/**
* Apply an offset (in kms) to a given latitude
*
* @param lat    latitude in degrees
* @param offSet distance to apply in kms
*
* @return float
*/
const calcOffsetLat = (lat, offSet) => {
  const p = Math.PI / 180;
  const newLat = lat + offSet / 6371 / p; // 6371 = earth radius in km +/-

  return parseFloat(newLat.toFixed(4));
};

/**
 * Apply an offset (in kms) to a given longitude
 *
 * @param lat    latitude in degrees
 * @param lng    longitude in degrees
 * @param offSet distance to apply in kms
 *
 * @return float
 */
const calcOffsetLng = (lng, lat, offSet) => {
  const p = Math.PI / 180;
  const newLong = lng + offSet / 6371 / p / Math.cos(lat * p); // 6371 = earth radius in km +/-

  return parseFloat(newLong.toFixed(4));
};

/**
 * returns the distance, in kms, between two points
 *
 * @param lat1 first latitude in degrees
 * @param lng1 first longitude in degrees
 * @param lat2 second latitude in degrees
 * @param lng2 seond longitude in degrees
 *
 * @return float
 */
const calcDistance = (lat1, lng1, lat2, lng2) => {
  const p = Math.PI / 180;
  const c = Math.cos;
  const a = 0.5
    - c((lat2 - lat1) * p) / 2
    + c(lat1 * p) * c(lat2 * p) * ((1 - c((lng2 - lng1) * p)) / 2);

  return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
};

const viewportSize = (viewport) => ({
  height: calcDistance(
    viewport.north,
    viewport.east,
    viewport.south,
    viewport.east,
  ),
  width: calcDistance(
    viewport.north,
    viewport.east,
    viewport.north,
    viewport.west,
  ),
});

const scaleUpToSmallestViewport = (viewport) => {
  const size = viewportSize(viewport);

  if (size.height >= viewportMinSize && size.width >= viewportMinSize) {
    return viewport;
  }

  const center = {
    lat: (viewport.north + viewport.south) / 2,
    lng: (viewport.east + viewport.west) / 2,
  };
  const newViewport = viewport;
  // We take into account a 5 percent error
  const offset = (viewportMinSize / 2) * 1.05;

  if (size.height <= viewportMinSize) {
    newViewport.north = calcOffsetLat(center.lat, offset);
    newViewport.south = calcOffsetLat(center.lat, -offset);
  }

  if (size.width <= viewportMinSize) {
    newViewport.east = calcOffsetLng(center.lng, center.lat, offset);
    newViewport.west = calcOffsetLng(center.lng, center.lat, -offset);
  }

  Logger.debug('Viewport scaled up', size, viewportSize(newViewport));

  return newViewport;
};

export default scaleUpToSmallestViewport;
